// extracted by mini-css-extract-plugin
export default {"csNoticeList":"Notice_csNoticeList__StteC","csNoticeItem":"Notice_csNoticeItem__SG09J"};